import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";
import { BASIC_INITIAL_STATE } from "@usas/ui-web/utils/HttpHelper";

const getDecryptedIdsData = (encryptedIds, state, setState) => {
  const api = initApi(API_NAMES.COMMON, state, setState);
  const url = `/App/DecryptId`;

  return api ? api.executeObject(url, 'POST', encryptedIds) : null;
};

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const ClubPerformanceData = {
  INITIAL_STATE,
  getDecryptedIdsData
};

export default ClubPerformanceData;